<template>
  <div class="yunxiao teacher student-name-repetitive" data-test="student-name-repetitive">
    <div class="repetitive-list-nave">
      <!-- 从顶部重复提示点击进入 -->
      <template v-if="entry == 1">
        <p class="tips" v-if="formPage === 'change'">关联学员后，学员原跟进人可继续跟进此意向</p>
        <p class="tips" v-else>以下为可能重复的{{scoped}}</p>
      </template>
      <!-- 从提交按钮点击进入：判断是否存在姓名+电话重复的 -->
      <template v-if="entry == 2">
        <p class="tips">{{enableAddOrUpdate?'以下为可能':'存在'}}重复的{{scoped}}</p>
      </template>
      <div 
        class="repetitive-student" 
        v-for="student of list" 
        :key="student.id">
        <div class="stu-main">
          <p class="title">
            <span>
              <span :class="{highlight: params.name === student.name}">{{student.name}}</span>
              <span class="sex-icon">{{student.sex || '男'}}</span>
            </span>
            <van-tag plain color="var(--g5)" text-color="var(--g6)" size="medium" v-if="student.intentionStatus==1">意向学员</van-tag>
            <van-tag plain color="var(--g5)" text-color="var(--g6)" size="medium" v-if="student.status==6">曾就读学员</van-tag>
            <van-tag plain color="var(--g5)" text-color="var(--g6)" size="medium" v-if="student.status==0 && student.intentionStatus!=1">未收费学员</van-tag>
            <van-tag plain color="var(--c1)" text-color="var(--c1)" size="medium" v-if="student.status==1">在读学员</van-tag>
            <van-tag plain color="rgba(var(--c3-rgb), 0.5)" text-color="var(--c3)" size="medium" v-if="student.status==99">无效</van-tag>
          </p> 
          <p class="infos">
            <label>登记校区：</label>
            {{ student.campusName }}
          </p>
          <p class="infos">
            <label>创建时间：</label>
            {{student.createTime|formatDatetime}}
          </p>
          <p class="infos" v-if="student.studentParentList && student.studentParentList.length">
            <label>联系方式：</label>
            <span>
              <span 
                class="relation-line"
                v-for="(relation,idx) of student.studentParentList" 
                :key="idx">
                <span>{{relation.relation}}</span>
                <span 
                  :class="{highlight: params.phoneList && params.phoneList.includes(relation.parentPhone)}">
                  {{relation.parentPhone}}
                </span>
              </span>
            </span>
          </p>
        </div>
        <div 
          class="stu-bottom van-hairline--top" 
          v-if="formPage === 'clue' || formPage === 'change'" >
          <span>与他重复，</span>
          <span class="link-text" @click="toBind(student)">直接关联</span>
        </div>
        <div v-else class="stu-bottom van-hairline--top">
          <span>与他重复，给他</span>
          <span class="link-text" @click="toNextPage(student)">报名收费</span>
        </div>
      </div>
      <div 
        class="repetitive-student" 
        v-for="student of intentionClueList" 
        :key="student.id">
        <div class="stu-main">
          <p class="title">
            <span>
              <span :class="{highlight: params.name === student.name}">{{student.name}}</span>
              {{student.sex || '男'}}
            </span>
            <van-tag plain color="var(--g5)" text-color="var(--g6)" size="medium" >意向</van-tag>
          </p>
          <p class="infos">
            <label>创建时间：</label>
            {{student.createTime|formatDatetime}}
          </p>
          <p class="infos" v-if="student.studentParentList && student.studentParentList.length">
            <label>联系方式：</label>
            <span>
              <span 
                class="relation-line"
                v-for="(relation,idx) of student.studentParentList" 
                :key="idx">
                <span>{{relation.relation}}</span>
                <span 
                  :class="{highlight: params.phoneList && params.phoneList.includes(relation.parentPhone)}">
                  {{relation.parentPhone}}
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <page-footer-btn multipleBtns>
      <van-button square round block @click="$router.back()" v-if="entry == 1">关闭</van-button>
      <template v-if="entry == 2">
        <van-button square round block @click="$router.back()" v-if="!enableAddOrUpdate">返回修改</van-button>
        <van-button square round block type="primary" @click="repetaConfirm" data-test="student-name-repetitive-btn-notRepetitive" v-else>不是重复数据，继续录入</van-button>
      </template>
    </page-footer-btn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'StudentNameRepetitive',
  filters: {
    formatDatetime (v, reg = 'yyyy-MM-dd hh:mm') {
      if (!v) return '-';
      return app.tool.date.formatDatetime(v, reg);
    }
  },
  data (){
    return {
      pageTitle: '重复数据提醒',
      scoped: this.$vxRoute.query.scoped||'学员',
      list: [],
      intentionClueList: [],
      params: {},
      formPage: this.$vxRoute.query.form,
      entry: this.$vxRoute.query.entry || 1, // 进当前页面的入口：1从页面顶部重复提示点击进入，2从提交入口进入
      enableAddOrUpdate: true,
    }
  },
  created () {
    // 获取重名学员数据
    let data = app.ls.getStorage('student-input-repetitive-datas');
    this.params = app.ls.getStorage('student-input-repetitive-params') || {};
    this.list.push(...(data.studentList || []))
    this.intentionClueList.push(...(data.intentionClueList || []))
    this.enableAddOrUpdate = data.enableAddOrUpdate; // 是否允许新增或修改（学员/意向）false否true是
  },
  methods: {
    // 非重名确认
    repetaConfirm() {
      app.vue.$emit('studentInputNameRepetitiveConfirm');
      this.$router.back();
    },
    // 根据入口，跳转不同页面
    toNextPage(student) {
      // 老生录入跳转班级选择
      if (this.$route.query.old) {
        this.$router.push('/studentChooseClass?id=' + student.id);
        return false;
      }
      // 学员登记跳转收费
      this.$router.push('/sf1?studentId=' + student.id)
    },
    toBind(stu) { 
      app.vue.$emit('clue-to-bind-student', stu);
      this.$router.back();     
    }
  },
  components: {
    pageFooterBtn,
  }
}
</script>

<style lang="scss">
.yunxiao.teacher.student-name-repetitive {
  display: flex;
  flex-direction: column;
  .repetitive-list-nave{
    flex: 1;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 12) calc(var(--gap) * 18);
    overflow-y: auto;
    color: var(--g6);
    >p.tips{
      margin: 0 0 calc(var(--gap) * 12) 0;
    }
    .repetitive-student{
      margin-bottom: calc(var(--gap) * 12);
      border-radius: calc(var(--w) * 8);
      background-color: var(--white);
      &:first-child{
        margin-top: calc(var(--gap) * 12);
      }
      .stu-main {
        padding: calc(var(--gap) * 16);
        .highlight{
          color: var(--c4);
        }
      }
      .stu-bottom {
        height: calc(var(--w) * 48);
        line-height: calc(var(--w) * 48);
        text-align: center;
        .link-text {
          color: var(--c1);
        }
      }
      p.title{
        display: flex;
        margin: 0 0 calc(var(--gap) * 16);
        justify-content: space-between;
        align-items: center;
        font-size: var(--fs-lg);
        font-weight: bold;
        color: var(--g8);
        >.van-icon-arrow{
          color: var(--g6);
        }
        >span.van-tag{
          white-space: nowrap;
        }
        .sex-icon {
          margin-left: calc(var(--gap) * 8);
          font-size:var(--fs-md);
          line-height:var(--lh-md);
          color: var(--g6);
          font-weight: normal;
        }
      }

      p.infos{
        margin: calc(var(--gap) * 8) auto;
        display: flex;
        .relation-line{
          display: block;
        }
      }
    }
  }
}
</style>